import { render } from "./WcSearchFormPage.vue?vue&type=template&id=5e08b256"
import script from "./WcSearchFormPage.vue?vue&type=script&lang=js"
export * from "./WcSearchFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__